export default __webpack_public_path__ + "images/446e0de406e8fbb1f9ab1bd9f9be4816-7316_NIYT_home_header_web_1919x543.jpg";